import { AxiosError } from 'axios';
import i18n from 'i18n';

import { showNotification } from 'components';
import { NotificationType } from 'models';

export function isAxiosError<Response = any>(e: any): e is AxiosError<Response> {
  return Boolean(e?.isAxiosError);
}

export enum DeleteWorkerUserErrors {
  NOT_FOUND = 'NOT_FOUND',
  WORKER_HAS_NOT_DELETED_PERFORMANCE_BASED_PAY = 'WORKER_HAS_NOT_DELETED_PERFORMANCE_BASED_PAY',
  WORKER_HAS_NOT_RECALLED_ACTIVE_TASKS = 'WORKER_HAS_NOT_RECALLED_ACTIVE_TASKS',
  WORKER_HAS_SM_ORDERS = 'WORKER_HAS_SM_ORDERS',
  WORKER_HAS_PENDING_SAP_UPLOADS = 'WORKER_HAS_PENDING_SAP_UPLOADS',
}

export function handleDeleteWorkerUserError(e: unknown): void {
  if (isAxiosError(e)) {
    if (e.response?.status === 404) {
      showNotification({
        content: i18n.t(`ERRORS.${DeleteWorkerUserErrors.NOT_FOUND}`),
        type: NotificationType.ERROR,
      });
      return;
    }

    if (e.response?.status === 400) {
      const errorMessage = e.response.data?.message;
      if (
        errorMessage === DeleteWorkerUserErrors.WORKER_HAS_NOT_DELETED_PERFORMANCE_BASED_PAY ||
        errorMessage === DeleteWorkerUserErrors.WORKER_HAS_NOT_RECALLED_ACTIVE_TASKS ||
        errorMessage === DeleteWorkerUserErrors.WORKER_HAS_SM_ORDERS ||
        errorMessage === DeleteWorkerUserErrors.WORKER_HAS_PENDING_SAP_UPLOADS
      ) {
        showNotification({
          content: i18n.t(`ERRORS.${errorMessage}`),
          type: NotificationType.ERROR,
        });
      }
    }
  }
}
